import { Dispatch, SetStateAction } from 'react';

import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import TimelineFilterForm from '@components/accountTimeline/timelineFilter/TimelineFilterForm';
import { TimelineFilters } from '@pages/accountTimeline/AccountTimeline';
import getEnumTranslation from '@utils/getEnumTranslation';

export type TimelineFilterDialogProps = {
    setTimelineFilters: Dispatch<SetStateAction<TimelineFilters>>;
    timelineFilters: TimelineFilters;
    filterTimelineOpen: boolean;
    setFilterTimelineOpen: Dispatch<SetStateAction<boolean>>;
    refetch?: () => void;
};

const TimelineFilterDialog = ({
    setTimelineFilters,
    timelineFilters,
    filterTimelineOpen,
    setFilterTimelineOpen,
    refetch,
}: TimelineFilterDialogProps) => {
    const handleCloseDialog = () => {
        setFilterTimelineOpen(false);
    };

    return (
        <PDialog
            dialogTitle={<>{getEnumTranslation('filter')}</>}
            onClose={handleCloseDialog}
            open={filterTimelineOpen}
            dialogSubtitle={
                <FormattedMessage
                    id="TimelineFilterModal.filterDesc"
                    defaultMessage="To filter your timeline items edit the fields below then click apply."
                />
            }>
            <TimelineFilterForm
                setTimelineFilters={setTimelineFilters}
                TimelineFilters={timelineFilters}
                setFilterTimelineOpen={setFilterTimelineOpen}
                refetch={refetch}
            />
        </PDialog>
    );
};

export default TimelineFilterDialog;
